import mutationTypes from './mutationTypes'
import actionTypes from './actionTypes'
import getterTypes from './getterTypes'
import { cloneDeep } from 'lodash'
import { Store } from 'vuex'
import { fetchCountries, fetchRegions } from '@/api/v1/data'
import { get3DigitCode } from '@/lib/countries'

interface MetaState {
  errors: Array<any>
  countriesList: Array<any>
  regionsList: Array<any>
  clientCountry: string | null
  printMode: boolean
}

const rootState: MetaState = {
  errors: [],
  countriesList: [],
  regionsList: [],
  clientCountry: null,
  printMode: false,
}

const mutations = {
  [mutationTypes.SET_ERROR.VALUE]: (state: MetaState, error: any) => {
    const errors = cloneDeep(state.errors)
    errors.push(error)
    state.errors = errors.slice(-5)
  },
  [mutationTypes.SET_COUNTRIES.VALUE]: (
    state: MetaState,
    countriesList: any[]
  ) => {
    state.countriesList = countriesList
  },
  [mutationTypes.SET_REGIONS.VALUE]: (state: MetaState, regionsList: any[]) => {
    state.regionsList = regionsList
  },
  [mutationTypes.SET_CLIENT_COUNTRY.VALUE]: (
    state: MetaState,
    countryCode: string
  ) => {
    state.clientCountry = countryCode
  },
  [mutationTypes.SET_PRINT_MODE.VALUE]: (
    state: MetaState,
    printMode: boolean
  ) => {
    state.printMode = printMode
  },
}

const actions = {
  [actionTypes.FETCH_COUNTRIES_LIST.VALUE]: async ({
    commit,
    state,
  }: Store<MetaState>) => {
    if (state.countriesList && state.countriesList.length) return
    const { data, error } = await fetchCountries()
    if (error) {
      return
    }
    commit(mutationTypes.SET_COUNTRIES.VALUE, data)
    return data
  },
  [actionTypes.FETCH_REGIONS_LIST.VALUE]: async (
    { commit, state }: Store<MetaState>,
    countryCode: string | null = null
  ) => {
    const cc = countryCode || state.clientCountry || null
    const { data, error } = await fetchRegions(get3DigitCode(cc))
    if (error) {
      return
    }
    commit(mutationTypes.SET_REGIONS.VALUE, data)
    return data
  },
  [actionTypes.SET_CLIENT_COUNTRY.VALUE]: (
    { commit }: Store<MetaState>,
    countryCode: string
  ) => {
    commit(mutationTypes.SET_CLIENT_COUNTRY.VALUE, countryCode)
  },
}

const getters = {
  [getterTypes.ERRORS.VALUE]: (state: MetaState) => {
    return state.errors
  },
  [getterTypes.COUNTRIES.VALUE]: (state: MetaState) => {
    return state.countriesList || []
  },
  [getterTypes.REGIONS.VALUE]: (state: MetaState) => (countryCode: string) => {
    if (!state.regionsList) {
      return []
    }

    return state.regionsList.filter((region: any) => {
      return region.country_code === countryCode
    })
  },
  [getterTypes.CLIENT_COUNTRY.VALUE]: (state: MetaState) => {
    return state.clientCountry
  },
  [getterTypes.PRINT_MODE.VALUE]: (state: MetaState) => {
    return state.printMode
  },
}

export default {
  namespaced: true,
  state: rootState,
  mutations,
  actions,
  getters,
}
